// extracted by mini-css-extract-plugin
export var medicalAdvisorySection = "MedicalAdvisoryBoardNew-module--medicalAdvisorySection--nNI5u";
export var sectionTitle = "MedicalAdvisoryBoardNew-module--sectionTitle--EgXss";
export var teamGrid = "MedicalAdvisoryBoardNew-module--teamGrid--FA-kW";